import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=68c81f5e&scoped=true&"
import script from "./HelpCenter.vue?vue&type=script&lang=ts&"
export * from "./HelpCenter.vue?vue&type=script&lang=ts&"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=68c81f5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c81f5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCol,VContainer,VLayout,VRow,VSimpleTable})
